export default function AmazonSalesBanner() {
  return (
    <div className='bg-mi-on-surface-accent-secondary py-2 text-center text-white text-base font-semibold leading-[25px] tracking-[-0.41px]'>
      <span>期間限定！Amazonで購入すると10%OFF</span>
      <br />
      <span>4月17日 23:59まで</span>
    </div>
  )
}
